import React, { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types';
import CustomModal from '../CustomModal'
import "./style.scss"

const CustomField = ({
    icon,
    title,
    placeholder,
    modalId,
    extraCssClass = "",
    onReset,
    isValid = true,
    children
}) => {
    const { t } = useTranslation()
    const [isOpenModal, setIsOpenModal] = useState(false)
    const fieldRef = useRef(null)
    const modalRef = useRef(null)
    const openModal = () => setIsOpenModal(true)
    const closeModal = () => setIsOpenModal(false)
    const tryCloseModal = () => modalRef.current && modalRef.current.canClose() && closeModal()

    useEffect(() => {
        const handleOutsideClick = (e) => {
            if (
                isOpenModal &&
                fieldRef.current &&
                !fieldRef.current.contains(e.target) &&
                !e.target.classList.contains('trip-btn--remove')
            ) {
                tryCloseModal()
            }
        }

        document.addEventListener('click', handleOutsideClick)

        return () => {
            document.removeEventListener('click', handleOutsideClick)
        }
    }, [isOpenModal]);

    return (
        <div
            className={`trip-field ${extraCssClass}`}
            ref={fieldRef}
            onClick={openModal}
        >
            <img src={icon} alt="" className="trip-field__icon" width={20} height={20} />
            <div className="trip-field__content">
                <span className="trip-field__title">{title}</span>
                <label className="trip-field__label">
                    {placeholder}
                </label>
            </div>
            {isOpenModal && (
                <CustomModal
                    ref={modalRef}
                    id={modalId}
                    onClose={closeModal}
                    onReset={onReset}
                    isValid={isValid}
                    headerText={t(`modal.${modalId}.header`)}
                >
                    {children}
                </CustomModal>
            )}
        </div>
    )
}

CustomField.propTypes = {
    icon: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    placeholder: PropTypes.string.isRequired,
    modalId: PropTypes.string.isRequired,
    extraCssClass: PropTypes.string,
    children: PropTypes.node,
    onReset: PropTypes.func
};

export default CustomField
